<div class="dialog-container">
  <mat-card class="no-shadow">
    <mat-card-header class="title">
      <mat-card-title class="no-subtitle">Pay Summary</mat-card-title>
      <button mat-icon-button color="primary" (click)="onCloseDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-header>

    <mat-card-content>
      <app-data-box headerTitle="Greater" class="mt-32">
        <div class="data-box-content text-sm">
          The greater of scheduled or actual flight time for this duty period.
        </div>
      </app-data-box>

      <app-data-box headerTitle="P/C" class="mt-24">
        <div class="data-box-content text-sm">
          <div>Pay and credit for this duty period.</div>
          <ul>
            <li>Generated from duty rig and/or deadhead time.</li>
            <li>
              <i>Contract provision isn't currently displayed (E, F, G, etc.).</i>
              To view the contract provision, select the sequence number which will open the HI3/HSS
              Sabre display. Look for the letter next to the P/C value.
            </li>
          </ul>
          <a href="https://www.alliedpilots.org/LinkClick.aspx?fileticket=XFPWb-VlEDo%3d&portalid=0" target="_blank"
            class="link text-sm">
            <mat-icon [inline]="true">launch</mat-icon>
            Compass Duty Rig Guide
          </a>
        </div>
      </app-data-box>

      <app-data-box headerTitle="Total" class="mt-24">
        <div class="data-box-content text-sm">Greater + P/C.</div>
      </app-data-box>
    </mat-card-content>
  </mat-card>
</div>